import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeProvider";
import Layout from "@/components/Layout";
import Index from "./pages/Index";
import Dual_Axis_Solar_Tracker from "./Projects/Dual_Axis_Solar_Tracker"
import Automated_Public_Lighting_System from "./Projects/Automated_Public_Lighting_System.tsx"
import Smart_Irrigation_System_using_Precision_Farming from "./Projects/Smart_Irrigation_System_using_Precision_Farming"
import Homelab_Cloud_Storage from "./Projects/Homelab_Cloud_Storage"
import Avinyaa_2025 from "./Projects/Avinyaa_2025"
import Inventory_Management_System from "./Projects/Inventory_Management_System"
import Bee_Solar_Website from "./Projects/Bee_Solar_Website.tsx"
import Book_Recommendation_System from "./Projects/Book_Recommendation_System"
import Recipe_Generator_AI from "./Projects/Recipe_Generator_AI"
import Hospital_Readmission_Prediction_System from "./Projects/Hospital_Readmission_Prediction_System"
import ProjectPage from "./pages/projects/[slug]";
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import CertificatePage from "./pages/Certificate";
import CLO3D_Garment_Plugin from "./Projects/CLO3D_Garment_Plugin";
import MS_Castle_Booking_App from "./Projects/MS_Castle_Booking_App";
import { useEffect } from 'react';

const queryClient = new QueryClient();

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider defaultTheme="dark" storageKey="portfolio-theme">
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/certificate" element={<CertificatePage />} />
            <Route path="/projects/:slug" element={<ProjectPage />} />
            <Route path="/Dual_Axis_Solar_Tracker" element={<Dual_Axis_Solar_Tracker/>} />
            <Route path="/Automated_Public_Lighting_System" element={<Automated_Public_Lighting_System/>} />
            <Route path="/Smart_Irrigation_System_using_Precision_Farming" element={<Smart_Irrigation_System_using_Precision_Farming/>} />
            <Route path="/Homelab_Cloud_Storage" element={<Homelab_Cloud_Storage/>} />
            <Route path="/Avinyaa_2025" element={<Avinyaa_2025/>} />
            <Route path="/Inventory_Management_System" element={<Inventory_Management_System/>} />
            <Route path="/Bee_Solar_Website" element={<Bee_Solar_Website/>} />
            <Route path="/book-recommender" element={<Book_Recommendation_System/>} />
            <Route path="/recipe-generator-ai" element={<Recipe_Generator_AI/>} />
            <Route path="/Hospital_Readmission_Prediction_System" element={<Hospital_Readmission_Prediction_System/>} />
            <Route path="/CLO3D_Garment_Plugin" element={<CLO3D_Garment_Plugin/>} />
            <Route path="/MS_Castle_Booking_App" element={<MS_Castle_Booking_App/>} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
        </Layout>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;